import { Menu } from "@chakra-ui/react";
import { PremiumSidebarProps } from "@ui/application";
import { usePremiumRoutes } from "@ui/utils";
import { PremiumMenuButton } from "./menu-button";
import { PremiumMenuList } from "./menu-list";
export interface PremiumMenuProps {
  name?: string | null;
  image?: string | null;
  routes: PremiumSidebarProps["tabs"];
}

export function PremiumMenuDesktop(props: PremiumMenuProps) {
  const { user } = usePremiumRoutes();

  return (
    <Menu isLazy>
      <PremiumMenuButton user={user} name={props.name} image={props.image} />
      <PremiumMenuList routes={props.routes} />
    </Menu>
  );
}
